import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@mui/styles';
import {DispatchContext} from '../../store';
import Paper from '@mui/material/Paper';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {Input} from '@mui/material';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(1),
    display: 'flex',
    flexBasis: 420
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  input: {
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.05px',
    height: 5
  }
}));

const KeywordSearch = props => {
  const {className, onChange, style, ...rest} = props;
  const classes = useStyles();
  const dispatch = useContext(DispatchContext);

  return (
    <Paper {...rest} className={clsx(classes.root, className)} style={{ boxShadow: "none", border: "1px solid grey " }}>
      <SearchRoundedIcon className={classes.icon} />
      <Input
        {...rest}
        className={classes.input}
        disableUnderline
        onChange={(e) => {
          dispatch({ type: "SEARCH", payload: false });
          onChange(e.target.value);
        }}
      />
    </Paper>
  );
};

KeywordSearch.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};
export default KeywordSearch;
